import config from './environment.config.json';

export interface EnvironmentConfig {
  isDevelopment: boolean;
  stripePublishableKey: string;
  apiCorePath: string;
  apiAuthenticationPath: string;
  apiMessagingPath: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience: string;
  applicationInsightsConnectionString: string;
  maxFileSizeMb: number;
  // Deploy-time substitution writes whatever the GitHub var holds, including a string (an unset var
  // substitutes as ""). resolveJsonModule infers that literally, so narrowing this to `number`
  // fails the build before INVITATION_EXPIRATION_DAYS() can apply its fallback.
  memberInvitationExpirationDays: number | string;
}

export const environment: EnvironmentConfig = config;
